const formatter = {
processNumberFormat(number) {
    //console.log(number)
    const newNumberFormat = number.replace(/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/, "$1-$2.$3.$4.$5.$6") 
    //console.log(newNumberFormat)
    return newNumberFormat
  }
}
export default formatter